//prettier-ignore
export const createPath = (baseFolder: string) => 
  (...segments: (string | number)[]) => [baseFolder, ...segments].join('/');

export const createUrl = (storage: string) => (path: string) =>
  `${storage}/${path}`;

export const VIDEO_WEBM = 'video.webm';
export const VIDEO_MP4 = 'video.mp4';
